import axios, {AxiosRequestConfig} from 'axios';
import {arrayStringify, parseMultiple} from './util';
import {getToken} from './token';

interface TranslateOptions {
  from?: string;
  to?: string;
  tld?: string;
  proxy?: boolean;
  client?: string;
}

interface TranslationError extends Error {
  language?: string;
  code?: number;
}

const translate = (
  data: string[],
  options: TranslateOptions,
): Promise<string[]> => {
  let e: TranslationError | undefined;
  options.from = options.from || 'auto';
  options.to = options.to || 'en';

  if (e) {
    e.code = 400;
    e.message = `The language '${e.language}' is not supported`;
    return new Promise((_, reject) => {
      reject(e);
    });
  }

  const tld = options.tld || 'com';

  return getToken(data.join(''), {
    tld: tld,
    proxy: options.proxy || false,
  }).then(res => {
    const text = arrayStringify(data);
    const url = '/translate_a/single';
    const query = {
      client: options.client || 'gtx',
      sl: options.from,
      tl: options.to,
      hl: options.to,
      dt: 't',
      ie: 'UTF-8',
      oe: 'UTF-8',
      otf: 1,
      ssel: 0,
      tsel: 0,
      kc: 7,
      [res.name]: res.value,
      q: text,
    };

    const headers = {
      'content-type': 'application/json',
      Accept: 'application/json, text/plain, */*',
      'X-Requested-With': 'XMLHttpRequest',
    };

    const extra: AxiosRequestConfig = {
      method: 'post',
      headers,
      baseURL: `https://translate.google.${tld}`,
      url,
      params: query,
      // proxy: options.proxy || undefined,
    };

    return axios(extra)
      .then(response => {
        const result = parseMultiple(response.data[0]);
        return Promise.resolve(result);
      })
      .catch(error => {
        return Promise.reject(error);
      });
  });
};

export default translate;
